import {AfterViewInit, Component, inject, NgZone, PLATFORM_ID} from '@angular/core';
import {HomeWhyCardYellowComponent} from './card/home-why-card-yellow/home-why-card-yellow.component';
import {HomeWhyCardOrangeComponent} from './card/home-why-card-orange/home-why-card-orange.component';
import {HomeWhyCardPinkComponent} from './card/home-why-card-pink/home-why-card-pink.component';
import {HomeWhyCardBlueComponent} from './card/home-why-card-blue/home-why-card-blue.component';
import {HomeWhyCardGreenComponent} from './card/home-why-card-green/home-why-card-green.component';
import {HomeWhyCardAssociation} from '../../../../model/home.model';
import {DOCUMENT, isPlatformBrowser} from '@angular/common';
import {HAMMER_LOADER, HammerStatic, WINDOW} from '../../../config/module.di.tokens';

@Component({
  selector: 'app-home-why',
  imports: [
    HomeWhyCardYellowComponent,
    HomeWhyCardOrangeComponent,
    HomeWhyCardPinkComponent,
    HomeWhyCardBlueComponent,
    HomeWhyCardGreenComponent
  ],
  templateUrl: './home-why.component.html',
  styleUrl: './home-why.component.scss'
})
export class HomeWhyComponent implements AfterViewInit {

  hammerLoader = inject(HAMMER_LOADER);
  window = inject(WINDOW)
  document = inject(DOCUMENT);
  platformId = inject(PLATFORM_ID)
  ngZone = inject(NgZone)
  currentCard = "yellow"
  homeWhyCardAssociations = new Array<HomeWhyCardAssociation>();
  transitionOccuring = false
  stopSliding = false

  async ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.ngZone.runOutsideAngular(() => {
        this.hammerLoader.then(hammer => this.initBrowser(hammer));
      })
    }
  }

  initBrowser(hammer: HammerStatic) {

    this.homeWhyCardAssociations.push({card: "yellow", behindCard: "orange", frontCard: null})
    this.homeWhyCardAssociations.push({card: "orange", behindCard: "pink", frontCard: "yellow"})
    this.homeWhyCardAssociations.push({card: "pink", behindCard: "blue", frontCard: "orange"})
    this.homeWhyCardAssociations.push({card: "blue", behindCard: "green", frontCard: "pink"})
    this.homeWhyCardAssociations.push({card: "green", behindCard: "green", frontCard: "blue"})
    this.homeWhyCardAssociations.forEach(cardAssociation => this.activeSwipe(hammer, cardAssociation))

    if (this.window.innerWidth >= 1024) {
      const mainScrollElement = this.document.querySelector(".main-scroll") as HTMLElement;
      mainScrollElement.addEventListener("wheel", (ev: WheelEvent) => this.animateOnWheel(ev), { passive: false });
    }
  }

  animateOnWheel(ev: WheelEvent) {

    if (this.isInView(ev)) {
      if (!(this.currentCard == "yellow" && ev.deltaY < 0 || this.currentCard == "green" && ev.deltaY > 0)) {
        ev.preventDefault()
        if (this.stopSliding) {
          this.stopSliding = false;
        }
      } if (!this.stopSliding) {
        ev.preventDefault()
        this.stopSliding = true;
      }

      if (!this.transitionOccuring) {
        this.transitionOccuring = true
        const homeWhyCardAssociation = this.homeWhyCardAssociations
          .find(homeWhyCardAssociation => homeWhyCardAssociation.card == this.currentCard)
        if (homeWhyCardAssociation) {
          if (ev.deltaY > 0 && homeWhyCardAssociation.card != "green") {
            this.forward(ev, homeWhyCardAssociation)
          } else if (ev.deltaY < 0 && homeWhyCardAssociation.frontCard) {
            this.reverse(ev, homeWhyCardAssociation)
          }
          setTimeout(() => this.transitionOccuring = false, 700)
        }
      }
    }

  }

  private isInView(event: WheelEvent) {

    const homeWhy = this.document.getElementById("home-why") as HTMLElement
    let isInView = false
    if (homeWhy) {
      const rect = homeWhy.getBoundingClientRect();
      const x = event.clientX;
      const y = event.clientY;

      isInView = x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom
    }
    return isInView
  }
  activeSwipe(hammer: HammerStatic, homeWhyCardAssociation: HomeWhyCardAssociation): void {

    if (homeWhyCardAssociation.card != "green") {
      const card = this.document.getElementById(`${homeWhyCardAssociation.card}-card`)
      const hammerM = new hammer.Manager(card, {
        recognizers: [
          [hammer.Swipe, { direction: hammer.DIRECTION_ALL }],
        ]
      });

      hammerM.on("swipeup", (ev) => this.forward(ev, homeWhyCardAssociation));
      hammerM.on("swipeleft", (ev) => this.forward(ev, homeWhyCardAssociation));
      if (homeWhyCardAssociation.frontCard) {
        hammerM.on("swipedown", (ev) => this.reverse(ev, homeWhyCardAssociation));
        hammerM.on("swiperight", (ev) => this.reverse(ev, homeWhyCardAssociation));
      }
    }
  }

  reverseAnimation(ev) {
    this.reverse(ev, this.homeWhyCardAssociations.find(card => card.card === "green"), false)
    this.reverse(ev, this.homeWhyCardAssociations.find(card => card.card === "blue"), false)
    this.reverse(ev, this.homeWhyCardAssociations.find(card => card.card === "pink"), false)
    this.reverse(ev, this.homeWhyCardAssociations.find(card => card.card === "orange"), false)
  }

  forward(event, homeWhyCardAssociation: HomeWhyCardAssociation, prevent = true) {
    if (prevent) {
      event.preventDefault();
    }
    const cardElement = this.document.getElementById(`${homeWhyCardAssociation.behindCard}-card`);
    const contentOfCard = cardElement.getElementsByClassName('content')[0] as HTMLElement;
    cardElement.classList.remove(`${homeWhyCardAssociation.behindCard}-card-animation-reverse`);
    cardElement.classList.add(`${homeWhyCardAssociation.behindCard}-card-animation`);
    contentOfCard.style.display = 'block';
    this.currentCard = homeWhyCardAssociation.behindCard;
  }

  reverse(event, homeWhyCardAssociation: HomeWhyCardAssociation, prevent = true) {
    if (prevent) {
      event.preventDefault();
    }
    const cardElement = this.document.getElementById(`${homeWhyCardAssociation.card}-card`);
    const contentOfCard = cardElement.getElementsByClassName('content')[0] as HTMLElement;
    cardElement.classList.remove(`${homeWhyCardAssociation.card}-card-animation`);
    cardElement.classList.add(`${homeWhyCardAssociation.card}-card-animation-reverse`);
    setTimeout(() => {
      contentOfCard.style.display = 'none';
    }, 800)
    this.currentCard = homeWhyCardAssociation.frontCard
  }



}
